import React from 'react';
import { connect } from 'react-redux';
import propTypes from 'prop-types';

import { resourceType } from 'constants/loading';

import { getMessage } from 'util/locale';
import { useRedirectUrl } from 'util/hooks/useRedirectUrl';

import { getQuitFlowModal } from 'current/selectors';

import { closeQuitFlowModal } from 'current/uiwidgets';
import { backToLandingPage } from 'scripts';
import { endPendingResourcesOfType } from 'loading';

// components
import BaseModal from 'common/modals/BaseModal';

const baseString = 'vra-advanced-script-cancel-modal';
let QuitFlowModalContainer = ({
  quitFlowModal,
  onCancelQuitFlowModal,
  onSaveQuitFlowModal
}) => {
  const redirectUrl = useRedirectUrl();

  return (quitFlowModal ? (
    <BaseModal
      footerText={ getMessage('footer-text__quit') }
      onCancel={onCancelQuitFlowModal}
      onSave={() => onSaveQuitFlowModal(redirectUrl)}
      saveText={getMessage('button-text__close-advanced')}>
      <div className={`${baseString}`}>
        { getMessage('text__quit') }
      </div>
    </BaseModal>
  ) : null);
};

QuitFlowModalContainer.propTypes = {
  onCancelQuitFlowModal: propTypes.func.isRequired,
  onSaveQuitFlowModal: propTypes.func.isRequired,
  quitFlowModal: propTypes.bool
};

QuitFlowModalContainer = connect(
  (state) => {
    return {
      quitFlowModal: getQuitFlowModal(state)
    };
  },
  (dispatch) => {
    return {
      onCancelQuitFlowModal: () => {
        dispatch(endPendingResourcesOfType({ type: resourceType.ADVANCED_SCRIPT_AVAILABILITY }));
        dispatch(endPendingResourcesOfType({ type: resourceType.ADVANCED_SCRIPT_RECOMMENDATIONS }));
        dispatch(closeQuitFlowModal());
      },
      onSaveQuitFlowModal: (redirectUrl) => {
        dispatch(closeQuitFlowModal());
        dispatch(backToLandingPage(redirectUrl));
      }
    };
  }
)(QuitFlowModalContainer);
export default QuitFlowModalContainer;
